import { useRouter } from 'next/router'
import React, { useState, useContext } from 'react'

//
import { Footer as FooterLMR } from '../../storybook'
import { getMicroCopy } from '../../utils/microcopy'
import { getUrl } from '../../utils/urls'
import { SiteDataContext, LocationContext } from '../page-wrapper'
import { useNavigationData } from '@/src/context/NavigationContext'
import { useMicroCopyData } from '@/src/context/MicroCopyContext'
import { useGlobalData } from '@/pages/_app'

const Footer = ({
  footerMainNavigation,
  footerSocialMedia,
  footerLegalNavigation,
  actions,
  minimalFooter = false,
  footerText = undefined
}) => {
  const router = useRouter()
  const { market, lang } = useContext(SiteDataContext)
  const { markets } = useGlobalData()
  const [activeCountry, setActiveCountry] = useState(router.locale)
  const [activeLanguage, setActiveLanguage] = useState(router.locale)
  const { navigationItems } = useNavigationData()
  const microCopyData = useMicroCopyData()

  const location = useContext(LocationContext)
  const { slugPrefix } = location

  const changeCountry = (value) => {
    setActiveCountry(value)
    router.push('/', null, { locale: value })
  }

  const changeLanguage = (e) => {
    setActiveLanguage(e)
    router.push('/', null, { locale: e })
  }

  const createFooterMenuGroup = (group) => {
    return {
      title: group.title,
      items: group.navigationItems.map((navigation) => ({
        label: navigation.title,
        url: getUrl({
          navItem: navigation,
          slugPrefix: slugPrefix,
          navigationItems: navigationItems
        }),
        id: navigation.title
      })),
      id: group.id
    }
  }

  const createFooterMainNav = (footerMainNavigation) => {
    const columns = [
      { id: 0, menus: [] },
      { id: 1, menus: [] },
      { id: 2, menus: [] },
      { id: 3, menus: [] }
    ]
    footerMainNavigation.forEach((group) =>
      columns[group.column - 1 || 0].menus.push(createFooterMenuGroup(group))
    )
    return columns
  }

  const createFooterSocial = (footerSocialMedia) => {
    const items = []
    footerSocialMedia.forEach((item) => {
      const url = getUrl({
        navItem: item,
        slugPrefix: slugPrefix
      })
      url.toLowerCase().includes('twitter') &&
        items.push({ label: 'twitter', url: url, id: item.id, icon: item.icon })
      url.toLowerCase().includes('facebook') &&
        items.push({ label: 'facebook', url: url, id: item.id, icon: item.icon })
      url.toLowerCase().includes('instagram') &&
        items.push({ label: 'instagram', url: url, id: item.id, icon: item.icon })
      url.toLowerCase().includes('linkedin') &&
        items.push({ label: 'linkedin', url: url, id: item.id, icon: item.icon })
      url.toLowerCase().includes('youtube') &&
        items.push({ label: 'youtube', url: url, id: item.id, icon: item.icon })
    })

    return {
      title: getMicroCopy({ key: 'social', data: microCopyData[lang] }),
      items
    }
  }

  const createFooterLegalMenu = (footerLegalNavigation) => {
    const items = []
    footerLegalNavigation.forEach((item) =>
      items.push({
        label: item.title,
        url: getUrl({
          navItem: item,
          slugPrefix: slugPrefix,
          navigationItems: navigationItems
        }),
        id: item.id
      })
    )
    return {
      items
    }
  }

  const createCountryList = (markets) => {
    const items = []

    markets.forEach((m) => {
      const item = {
        label: getMicroCopy({
          key: `market.${m.countryIsoCode.toLowerCase()}`,
          data: microCopyData[lang]
        }),
        id: m.title,
        value: null
      }
      const defaultLanguage = m.defaultLanguage

      const doesMarketHaveCurrentLanguage = m.locales.find(
        (locale) => locale.split('-')[0] === lang
      )

      if (!doesMarketHaveCurrentLanguage) {
        const locale = m.locales.find((locale) => locale.split('-')[0] === defaultLanguage)
        item.value = `${locale}`
      } else {
        const locale = m.locales.find((locale) => locale.split('-')[0] === lang)
        item.value = `${locale}`
      }

      items.push(item)
    })

    return items
  }

  const createLanguageList = () => {
    const items = []

    market.languages.forEach((lng) => {
      const value = market.isoCode === 'XX' ? lng : `${lng}-${market.isoCode.toLowerCase()}`
      items.push({
        label: getMicroCopy({ key: `languages.${lng}`, data: microCopyData[lang] }),
        value: value,
        id: lng
      })
    })
    return items
  }

  return (
    <>
      <FooterLMR
        footerMenus={createFooterMainNav(footerMainNavigation)}
        legalMenu={createFooterLegalMenu(footerLegalNavigation)}
        socialMenu={createFooterSocial(footerSocialMedia)}
        actions={actions}
        languageCountryMenu={{
          title: getMicroCopy({ key: 'languageAndCountry', data: microCopyData[lang] }),
          languageItems: createLanguageList(),
          countryItems: createCountryList(markets)
        }}
        microCopyData={microCopyData[lang]}
        language={activeLanguage}
        country={activeCountry}
        handleSelectCountry={(e) => changeCountry(e)}
        handleSelectLanguage={(e) => changeLanguage(e)}
        footerText={
          footerText || {
            companyInfo: getMicroCopy({ key: 'companyInfo', data: microCopyData[lang] }),
            copyright: getMicroCopy({
              key: 'copyright',
              tokens: { year: new Date().getFullYear() },
              data: microCopyData[lang]
            })
          }
        }
        minified={minimalFooter}
      />
    </>
  )
}

export default Footer
